<template>

  <v-app dark>

    <!--<v-overlay
      :absolute="true"
      :value="$store.state.login.loading"
      z-index="5"
    >
      <v-progress-circular
        :size="50"
        color="success"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay> -->

    <core-toolbar/>

    <core-drawer/> 

    <core-view />

  </v-app>

</template>

<script>

export default {
  name: 'Painel',
  components: { },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/index.scss';

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}

</style>


// WEBPACK FOOTER //
// src/views/Painel.vue